import React, { useEffect, useRef, useState } from 'react';

import { TextField, Grid, IconButton, Tooltip } from '@material-ui/core';
import { EditIcon } from '../../icons';

const EditableTextbox = ({ label, placeholder, text, setText, children }) => {
    const inputField = useRef(null);
    const [editing, setEditing] = useState(false);
    const [editedText, setEditedText] = useState(text);

    useEffect(() => {
        if (editing && inputField && inputField.current) {
            inputField.current.focus();
        }
    }, [editing]);

    const onFinished = () => {
        setEditing(false);
        setText(editedText);
    };

    return (
        <>
            <Grid style={{ display: editing ? '' : 'none' }} container alignItems="center">
                <TextField
                    label={label}
                    type="text"
                    inputRef={inputField}
                    value={editedText}
                    onChange={event => setEditedText(event.target.value)}
                    onBlur={() => onFinished()}
                    onKeyPress={event => {
                        if (event.charCode === 13) {
                            onFinished();
                        }
                    }}
                />
            </Grid>
            {!editing && (
                <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                        <h4>{text || placeholder}</h4>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={() => setEditing(true)}>
                            <Tooltip title="Edit rule name">
                                <EditIcon />
                            </Tooltip>
                        </IconButton>
                        {children}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default EditableTextbox;
